import classnames from 'classnames';
import React from 'react';
import noProfilePicIcon from 'assets/icons/contact_noimage.svg';
import './ProfileImage.pcss';
import { ImageWithFallback } from '../../../../../common/components/ImageWithFallback/ImageWithFallback';

type Props = {
  altText: string;
  profilePictureUrl: string | undefined | null;
  big?: boolean;
  size?: number;
  className?: string;
  css?: {
    container?: string;
  };
};

export const ProfileImage = ({
  altText,
  big,
  size,
  profilePictureUrl,
  className,
  css,
}: Props) => {
  const finalClassName = classnames(
    className,
    'live-chat--conversation__profile-image',
  );

  const containerClassName = classnames(css?.container);

  const effectiveSize = size || (big && 40);
  const style = effectiveSize
    ? { width: effectiveSize, height: effectiveSize }
    : undefined;

  return (
    <div className={containerClassName}>
      <ImageWithFallback
        src={profilePictureUrl}
        fallbackImage={noProfilePicIcon}
        className={finalClassName}
        alt={altText}
        style={style}
      />
    </div>
  );
};
